import {KpiGrid} from '@sdox/ui'

import type {KpiItemProps} from '@sdox/ui'
import type {XcNwBlock_KpiTypeBlockRowType_Fragment} from '@sdox/api'

export const BlockKpiRow = ({items}: XcNwBlock_KpiTypeBlockRowType_Fragment) => {
  const kpis = items.map(
    (item): KpiItemProps => ({
      unit: item.suffix ?? undefined,
      value: item.__typename === 'KpiNumberType' ? item.numberValue : item.stringValue,
      title: item.title,
      subtitle: item.subtitle ?? undefined,
      variant: item.__typename === 'KpiNumberType' ? item.kpiVariant : undefined,
    }),
  )

  return <KpiGrid items={kpis} />
}
